import React from 'react';
import styled from '@emotion/styled';
import { Cheque } from '@baemingo/table-events/dist/types';
import { useTableUniverse } from '~Components/TableUniverse';
import ChequePayment from './ChequePayment';
import { useI18n } from '~Hooks';

const Wrapper = styled.div`
  animation: fade-in 0.15s cubic-bezier(0.215, 0.61, 0.355, 1);
  flex: 1;
`;
interface Props {
  selectedCheque: Cheque;
}

const SelectedCheque = ({ selectedCheque }: Props): JSX.Element => {
  const { i18n } = useI18n();
  const universe = useTableUniverse();

  const payments = universe.payments?.filter((p) => p.chequeId === selectedCheque.id);

  return (
    <Wrapper>
      {i18n('History.Payments')}
      {payments?.map((p) => (
        <ChequePayment key={p.id} payment={p} chequeId={selectedCheque.id}></ChequePayment>
      ))}
    </Wrapper>
  );
};

export default SelectedCheque;
